import mappings from "modules/shared/models/mappings/mappings"

export default {
  authLogin: {
    authReference: {
      environmentId: mappings.Agency.environmentId,
      userId: "",
      subscriptionId: "",
      companyId: "",
      agencyId: ""
    },
    authModal: {
      type: "",
      mode: ""
    },
    authCredential: {
      method: "password",
      credentials: {
        username: "",
        password: ""
      }
    },
    authSession: {
      id: "",
      member: ""
    },
    authCallback: {
      url: "string",
      userId: "string",
      password: "string",
      auth: "string",
      retries: "string"
    },
    authNotify: {
      email: "string",
      sms: "",
      push: ""
    }
  }
}